import { useNavigate, useLocation } from "react-router-dom";
import { getPromoPrefix } from "../utils/promoPath";

const useNavi = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return () => navigate(`${getPromoPrefix(pathname)}/eligibility`);
};

export default useNavi;
